import { render, staticRenderFns } from "./RegisteredUser.vue?vue&type=template&id=28f08b06"
import script from "./RegisteredUser.vue?vue&type=script&lang=js"
export * from "./RegisteredUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports